module.exports = __webpack_public_path__ + "img/landing_mockup_2.be35a548.png";